/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: Reconocimientose_incController
* # alias: Perfil
*/
import rec from './rec.json';
export default class Reconocimientose_incController {

    constructor($scope, $state, $stateParams, ngNotify,SERVICE_URL_CONSTANT, $timeout, UserInfoConstant, perfilSrv, moment, $cookies,$window) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.ngNotify = ngNotify;
        this.$stateParams = $stateParams;
        this.perfilSrv = perfilSrv;
        this.moment = moment;
        this.$cookies = $cookies;
        this.$window = $window;
        this.userinfo = null;
        this.downloadFileSrv = SERVICE_URL_CONSTANT.rosario + "/perfil/downloadFileCV";
        this.slick = {
            viewData: [],
            viewLoaded: false, 
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            carouselResponsiveBreakpoints: [
             {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }, {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              }, {
                breakpoint: 1920,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              }, {
                breakpoint: 3000,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4
                }
              }
            ]
        }
        this.$scope.UserInfoConstant = UserInfoConstant;
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.userinfo.role_id = this.$cookies.get('hasRoleId');
                this.main();
            }
        });
    }

    main() {
        /**
        * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
        **/
        if (this.$stateParams.teacherId != '') {
            this.userinfo.teacherId = this.$stateParams.teacherId;
            this.reconocimientros(this.userinfo.teacherId);
        } else {
            this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
                if (!response.status) {
                    this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
                } else {
                    this.role = response.data[0];
                    if (this.role.types == 'TEACHER') {
                        this.getInfo();
                    } else {
                        this.$state.go('profile.perfil_dash');
                        this.ngNotify.set('No se ha especificado ningún docente', 'info');
                    }
                }
            }, (err) => {
                this.ngNotify.set('Imposible conectar con el servicio', 'error');
            });
        }
    }

    goBack(){
        this.$state.go('profile.perfil_dash', {teacherId:this.$stateParams.teacherId})
    }
    
    getInfo() {
        this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher;
                this.reconocimientros(this.userinfo.teacherId);
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    download(item){
        var documentPath = item.document_url;
        documentPath = documentPath.replace(/\//g, ',');
        let params = {
            rut: item.id_rut,
            fileName: item.document_suport,
            filePath: documentPath
        }

        this.$window.open(this.downloadFileSrv+"/"+params.rut+"/"+params.filePath+"/"+encodeURIComponent(params.fileName) )
    }

    getPDF() {
        var body = [];
        for (var i in this.slick.viewData) {
            body.push([{text:this.slick.viewData[i].ack_year + ' - ' + this.slick.viewData[i].ack_acknowledgment , colSpan:2,bold: true,alignment: 'center'}, {text:''}])
            body.push(['Tipo',this.slick.viewData[i].ack_type])
            body.push(['Unidad',this.slick.viewData[i].academic_unit])
            body.push(['N° de decreto',this.slick.viewData[i].num_decret])
            body.push(['Fecha Ceremonia',moment(this.slick.viewData[i].date_ceremony).format('DD-MM-YYYY')])
            body.push([{text:' ', colSpan:2}, {text:''}])
        }

        var docDefinition = {
            content:[
                { text: 'Reconocimientos e incentivos', style: 'header',bold: true,alignment: 'center',fontSize: 22 },
                { text: '_______________________________________________________________________________________', style: 'anotherStyle' },
                {
                    table:{
                        widths:[150, 302],
                        body
                    }
                }
            ]
        };

        pdfMake.createPdf(docDefinition).download('export.pdf');
    }


    reconocimientros(teacherId) {
        this.slick.viewLoaded = false;
        this.perfilSrv.perfildocente.reconocimientoSeincentivos({teacherId:teacherId}).$promise.then((response) => {
            this.reconocimiento = response.data;
            for (let i in this.reconocimiento) {
                var item = this.reconocimiento[i];

                item.hasSupportDoc = (item.document_suport) ? true : false;
                item.hasSupportUrl = (item.document_url) ? true : false;
                item.supportDocumentClass = (item.hasSupportDoc && item.hasSupportUrl) ? 'mdi-action-done text-verde' : 'mdi-navigation-cancel text-rojo'

                this.slick.viewData.push(item);
            }
            this.slick.viewLoaded = true;
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });        
    }
}

Reconocimientose_incController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify','SERVICE_URL_CONSTANT', '$timeout', 'UserInfoConstant', 'perfilSrv', 'moment', '$cookies','$window'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/Reconocimientose_inc/Reconocimientose_incController.js